module.exports = __webpack_public_path__ + "media/images/announceGroup__icon-e2619c6ac3fe0835f1af7bfd981e1fcf.png";